import React, { useEffect, useState } from "react";
import { IonCol, IonGrid, IonRow, IonSpinner, useIonViewWillEnter } from "@ionic/react";

import { useConfig } from "../data/store/useConfig";
import { useProfile } from "../data/store/useProfile";
import { useSongs } from "../data/store/useSongs";
import { toDate, useIdParam, usePageTitle } from "../util/sugar";
import { ENABLE_GROUPS } from "../config/env";

import Content from "../components/Content";
import PleaseLoginCard from "../components/PleaseLoginCard";
import RequestAccessCard from "../components/RequestAccessCard";
import SongItem from "../components/SongItem";
import { app } from "../services/LoginService"
import firebase from 'firebase/compat/app';
const SongDetail: React.FC = (props) => {
  const id = useIdParam(props);
  const { shouldFetch, fetch } = useSongs();
  const song = useSongs((x) => x.retrieve(id));
  const unauthenticated = useProfile((x) => x.status === "unauthenticated");
  const authorId = useProfile((x) => x.authorId);
  const isAlumni = useConfig((x) => x.isAlumni());
  // Start in the loading state when the song still has to be fetched, so a
  // guest opening a public song's link never flashes the login card first.
  const [loading, setLoading] = useState(() => !song && shouldFetch(id));

  const songTitle = song
    ? song.title + " " + toDate(song.updatedAt)
    : "loading";

  usePageTitle(songTitle);

  useEffect(() => {
    if (song || !shouldFetch(id)) return;
    setLoading(true);
    Promise.resolve(fetch(id)).finally(() => setLoading(false));
  }, [id]);
  useIonViewWillEnter(() => {
    firebase.analytics(app).logEvent("view_song", { songId: id })
  }, [])

  // A public song is listenable by anyone, signed in or not, member of a
  // group or not (the rules already let anyone read it; share links land
  // here). Group-based instances keep the login/membership gates for every
  // other song.
  const isPublicSong = song?.privacy === "public";
  if (!isPublicSong && ENABLE_GROUPS && !loading) {
    if (isAlumni === false) {
      return (
        <Content>
          <RequestAccessCard authorId={authorId} />
        </Content>
      );
    }
    if (unauthenticated) {
      return (
        <Content>
          <PleaseLoginCard action="see this page" />
        </Content>
      );
    }
  }

  return (
    <Content className="background-wall">
      <IonGrid>
        <IonRow>
          <IonCol sizeMd="8" sizeLg="6" offsetMd="2" offsetLg="3">
            {song ? (
              <SongItem key={song.id} id={song.id}></SongItem>
            ) : loading ? (
              <IonRow className="ion-justify-content-center">
                <IonSpinner name="dots" />
              </IonRow>
            ) : unauthenticated ? (
              // Public songs load for everyone. If it didn't load, the song is
              // Members Only (denied server-side) — prompt the visitor to log in.
              <PleaseLoginCard action="listen to this song" />
            ) : null}
          </IonCol>
        </IonRow>
      </IonGrid>
    </Content>
  );
};

export default SongDetail;
